import React from 'react';
import { Link, type To } from 'react-router-dom';

import { ETabButton } from '../enums/TabButtonType';
import CTabButton from './CTabButton';

interface LinkTabButtonProps {
  to: To;
  isSelected: boolean | undefined;
  label: string | undefined;
  text?: string | JSX.Element;
  labelKey?: string;
  onClick?: (selectedTab: string | undefined) => void;
}

export default function LinkTabButton(props: LinkTabButtonProps) {
  return (
    <Link to={props.to} className={'inline-block'}>
      <CTabButton
        isSelected={props.isSelected}
        label={props.label}
        labelKey={props.labelKey}
        text={props.text}
        onClick={props.onClick ?? (() => undefined)}
        buttonType={ETabButton.LINK}
      />
    </Link>
  );
}
